import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Cell } from "./Cell";

export class BubblesContainer extends Phaser.GameObjects.Container {

    private bubblesData: {img: Phaser.GameObjects.Image, x: number, a: number, v: number, dA: number, topY: number} [];
    private storedBubblesData: {img: Phaser.GameObjects.Image, x: number, a: number, v: number, dA: number, topY: number} [];

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.bubblesData = [];
        this.storedBubblesData = [];

        this.increasePoolSize(10);
    }

    public update(): void {

        let outOfScreenBubbleData: {img: Phaser.GameObjects.Image, x: number, a: number, v: number, dA: number, topY: number} = null;
        
        for (let i = 0; i < this.bubblesData.length; i ++) {

            this.bubblesData[i].a += this.bubblesData[i].dA;
            this.bubblesData[i].img.y -= this.bubblesData[i].v;
            this.bubblesData[i].img.x = this.bubblesData[i].x + 12 * Math.sin(this.bubblesData[i].a);

            this.bubblesData[i].v += .1;
            
            let sx = this.bubblesData[i].img.scaleX;
            sx *= 1.0025;
            this.bubblesData[i].img.setScale(sx, sx * GameVars.scaleY);

            if (this.bubblesData[i].img.y < this.bubblesData[i].topY) {
                outOfScreenBubbleData = this.bubblesData[i];
            }
        }

        if (outOfScreenBubbleData) {

            const i = this.bubblesData.indexOf(outOfScreenBubbleData);
            this.bubblesData.splice(i, 1);
            this.storedBubblesData.push(outOfScreenBubbleData);

            this.remove(outOfScreenBubbleData.img);
        }

        // EMITIR UNA BURBUJA DE TANTO EN TANTO
        if (Math.random() > .99) {
            const x = GameConstants.GAME_WIDTH * Math.random() - GameConstants.GAME_WIDTH * .5;
            const bubleImg = this.getBubble(x, GameConstants.GAME_HEIGHT);
            this.add(bubleImg);
        }
    }

    public emitBubbles(cell: Cell): void {

        if (!cell) {
            return;
        }
        
        if (Math.random() > .4) {

            const n = Math.floor(Math.random() * 4) + 1;

            for (let i = 0; i < n; i++) {

                const x = cell.x + 7.5 - 15 * Math.random();
                const y = cell.y + 7.5 - 15 * Math.random();

                this.scene.time.delayedCall(Math.floor(50 + 50 * Math.random()), function(): void {
                    this.add(this.getBubble(x, y));
                }, [], this);  
            }
        }
    }

    private emitBubble(): void {

        const bubble = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "bubble");
        bubble.setScale(.6 + .4 * Math.random());
        let topY: number;

        this.storedBubblesData.push({img: bubble, x: bubble.x, a: 0, v: 2.5 + 3 * Math.random(), dA: .1 + .1 * Math.random(), topY: topY});
    }

    private increasePoolSize(size: number): void {
        
        for (let i = 0; i < size; ++i) {
            this.emitBubble();
        }
    }

    private getBubble(x: number, y: number, emmitOutOfTheScene?: boolean): Phaser.GameObjects.Image {

        if (this.storedBubblesData.length === 0) {
            this.increasePoolSize(5);
        }
        const bubble = this.storedBubblesData.pop();
        // reset
        bubble.img.setScale(.6 + .4 * Math.random());
        
        bubble.img.setPosition(x, y);
        bubble.x = x;

        bubble.topY = emmitOutOfTheScene ? 0 : -GameConstants.GAME_HEIGHT / 2 / GameVars.scaleY;

        this.bubblesData.push({img: bubble.img, x: bubble.img.x, a: 0, v: 2.5 + 3 * Math.random(), dA: .1 + .1 * Math.random(), topY: bubble.topY});

        return bubble.img;
    }
}
